import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";

import { withElementWrapper } from "../../../../arrow/components/Atoms/StoryElements/withElementWrapper";
import { RightArrow } from "../../../../arrow/components/Svgs/right-arrow";

import "./cta-text.m.css";

const CtaTextBase = ({ element = {}, AdComponent, rightArrow = false, ...restProps }) => {
  const content = element?.text;
  if (!content) return null;

  const newTextElement = content.match(/(<([^>\s]+)(?:\s[^>]*)?>.*?<\/\2>|<[^>\s]+(?:\s[^>]*)?\/>)/g);
  let href = "";

  if (rightArrow) {
    const htmlString = newTextElement[0];
    href = htmlString.match(/href="([^"]*)"/)?.[1] || "";
  }

  return newTextElement.map((item, index) => {
    if (item.includes("ad_goes_here")) {
      const adIndexNo = JSON.parse(item.replace(/<[^>]*>/g, "")).index;
      return AdComponent ? <AdComponent key={index} adIndexNo={adIndexNo} /> : null;
    }

    return (
      <Link key={index} styleName="text-svg-container" href={href}>
        <div
          className="arrow-component arr--text-element"
          styleName="text-element"
          data-test-id="text"
          id="text-element"
          dangerouslySetInnerHTML={{ __html: item }}
          {...restProps}
        />
        {rightArrow && <RightArrow color="#C6554F" />}
      </Link>
    );
  });
};

CtaTextBase.propTypes = {
  element: PropTypes.shape({ text: PropTypes.string }),
  AdComponent: PropTypes.node,
  rightArrow: PropTypes.bool,
};

export const CtaText = withElementWrapper(CtaTextBase);
